require('./controllers/application.js');
require('./controllers/auto_save.js');
require('./controllers/change_palette.js');
require('./controllers/editing.js');
require('./controllers/editing_document.js');
require('./controllers/editor_proxy.js');
require('./controllers/frame_comm_manager.js');
require('./controllers/help_manager.js');
require('./controllers/history_operations.js');
require('./controllers/icons_images.js');
require('./controllers/image_gallery.js');
require('./controllers/image_toolbar.js');
require('./controllers/launch_platform.js');
require('./controllers/loading.js');
require('./controllers/main_tab_panel.js');
require('./controllers/modal.js');
require('./controllers/overlay.js');
require('./controllers/pexels_images.js');
require('./controllers/pattern_images.js');
require('./controllers/preview.js');
require('./controllers/saved_images.js');
require('./controllers/template.js');
require('./controllers/themes.js');
require('./controllers/toolbar.js');
require('./controllers/upload.js');
require('./controllers/view_options.js');
